import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { InfoCode } from 'src/app/models/domain';
import { YPMINFOCODESSRVInfocodes } from 'src/generated-clients/infocodes';

@Injectable({
  providedIn: 'root',
})
export class InfoCodeAdapter implements IAdapter<InfoCode, YPMINFOCODESSRVInfocodes> {
  public adaptToDomain(item: YPMINFOCODESSRVInfocodes): InfoCode {
    return new InfoCode(
      fallbackString(item.materialNumber),
      fallbackString(item.codeGroup),
      fallbackString(item.activityCode),
      fallbackString(item.activityCodeText),
      fallbackString(item.activityText),
      fallbackString(item.activityNo),
      fallbackString(item.createdBy),
      fallbackString(item.longText),
      item.longTextAvailable === 'X',
      fallbackString(item.notificationNo),
      fallbackDate(item.createdOn) ?? undefined
    );
  }
}
